import Http from './http'
// import {The_Ability} from '../store/index'

export default {
	index(filter){
    return Http.get(`/company_custom_pdfs`, {params: {...filter}})
  },
  
  show(id){
    return Http.put(`/company_custom_pdfs/${id}`)
  },

  create(done_forms){
    return Http.post(`/company_custom_pdfs`, {
      done_forms: {...done_forms}
    })
  }
}